import { Howl } from 'howler';

const sounds = {
  click: '/sounds/click.mp3',
  create: '/sounds/clink.mp3',
  navigate: '/sounds/clonk.mp3',
} as {
  [key: string]: any;
};

export default (instance: any) => {

  const sound = (ctx: IView) => ({
    play(ref: string) {
      // don't bother if enableSound disabled
      if (!ctx.$store.state.enableSound) {
        return;
      }

      const libraryObject = sounds[ref];
      if (typeof libraryObject === 'string') {
        sounds[ref] = new Howl({
          src: [libraryObject],
          html5: true,
          volume: 0.4,
        });
      }

      sounds[ref].play();
    },
  });

  instance.mixin({
    created() {
      this.$sound = sound(this);
    },
  } as IView);

};
